<template>
    <div>
        <div class="app-title" v-if="!isIOS">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <app-content>
            <DrawerHandler is-left class="col-3">
                <!--                <diverse-input :config="selectConfig" :value.sync="cameraId"></diverse-input>-->
                <key-value-cell horizontal :value="task.projectCode">项目号</key-value-cell>
                <key-value-cell horizontal :value="task.projectName">项目名称</key-value-cell>
                <key-value-cell horizontal :value="task.machine1">机型</key-value-cell>
                <key-value-cell horizontal :value="task.startTime">开始时间</key-value-cell>
                <key-value-cell horizontal :value="task.finishedTime">结束时间</key-value-cell>
            </DrawerHandler>
            <div class="card col overflow-auto" v-if="totalCount > 0">
                <div class="row d-flex flex-wrap h-100">
                    <template v-for="(item,index) of cameraList">
                        <div :class="blockClass" :key="index">
                            <RitaVideoHLS ref="ritaVideo" :camera-id="item.value" :task-id="task.id"></RitaVideoHLS>
                        </div>
                    </template>
                    <template v-for="item of diagramList">
                        <div :class="blockClass" :key="item" @dblclick="diagramToFullscreen(item)">
                            <customized-diagram :class="fullScreenCode===item?'full-screen font-cover':''"
                                                :ref="`RITA-${item}`"
                                                :diagram-code="item"
                                                disable-scale></customized-diagram>
                        </div>
                    </template>
                </div>
                <div class="back-cover background-cover" v-if="fullScreenCode!=null"></div>
            </div>
        </app-content>
    </div>
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import AppContent from "@/components/echarts-part/stuff/AppContent";
import RitaVideoHLS from "@/views/sithMes/rita/video/RitaVideoHLS";
import CustomizedDiagram from "@/components/LayoutMaps/openLayers/CustomizedDiagram";

export default {
    name: "RitaCameraPage",
    mixins: [emCommonListMixin],
    components: {CustomizedDiagram, RitaVideoHLS, AppContent, KeyValueCell, DrawerHandler},
    data() {
        return {
            task: {},
            cameraList: [],
            diagramList: [],
            fullScreenCode: null,
            logLeaving: false
        }
    },
    computed: {
        taskId() {
            return this.$route.query.taskId;
        },
        isIOS() {
            let u = navigator.userAgent;
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        totalCount() {
            return this.cameraList.length + this.diagramList.length;
        },
        blockClass() {
            let temp = this.totalCount > 1 ? 'col-6' : 'col-12';
            temp += ' ';
            temp += this.totalCount > 2 ? 'h-50' : 'h-100';
            return temp;
        },
    },
    watch: {
        task: {
            handler(val) {
                if (val.hasOwnProperty('cameraIdList')) {
                    let cameraIdList = val.cameraIdList;
                    let tempList = [];
                    for (let i = 0; i < cameraIdList.length; i++) {
                        tempList.push({
                            value: cameraIdList[i].id,
                            text: cameraIdList[i].name
                        })
                    }
                    this.cameraList = tempList;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getRemoteData();
        this.reloadWhenBackPage();
        document.addEventListener('keydown', this.whenKeyDown);
        document.addEventListener('pagehide', this.logLeave);
        window.onunload = this.logLeave;
        window.onbeforeunload = this.logLeave;
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.whenKeyDown);
        document.removeEventListener('pagehide', this.logLeave);
        this.$store.commit('customizedDiagram/setComputedHistoryQuery', null);
        this.logLeave();
    },
    methods: {
        getRemoteData() {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaTestTask/queryWithCamera?taskId=" + this.taskId,
            }).then(response => {
                console.log(response);
                this.task = response.data;
                if (this.task.diagramCodes) {
                    this.diagramList = this.task.diagramCodes.split(",");
                }
                if (this.task.startTime) {
                    this.$store.commit('customizedDiagram/setComputedHistoryQuery', {
                        startDate: this.task.startTime,
                    })
                }
            })
        },
        reloadWhenBackPage() {
            let _this = this;
            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) {
                    let targets = _this.$refs.ritaVideo;
                    for (let item of targets) {
                        item.reInitPlayer();
                    }
                }
            });
        },
        diagramToFullscreen(id) {
            this.fullScreenCode = id;
            this.$refs[`RITA-${id}`][0].resizeChart();
        },
        whenKeyDown(event) {
            if (event && event.code === 'Escape') {
                this.$refs[`RITA-${this.fullScreenCode}`][0].resizeChart();
                this.fullScreenCode = null;
            }
        },
        logLeave() {
            if (!this.logLeaving) {
                this.logLeaving = true;
                let jwt = localStorage['em_sso_token'];
                let url = process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaTestTask/leavePage" + `?token=${jwt}`;
                let blob = new Blob([], {
                    type: 'application/x-www-form-urlencoded',
                });
                navigator.sendBeacon(url, blob);
            }
        },
    }
}
</script>

<style scoped>
.font-cover {
    z-index: 5100 !important;
}

.background-cover {
    z-index: 5099 !important;
}
</style>